import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import * as TagNames from './dropdownmenu.tagnames.ts';
import { DropDownMenuItemClickEvent } from './dropdownmenu.events.ts';
import {
   enumAttributeConverter,
   Sizes,
   SizesValuesMap,
} from '../enum-types.ts';
import { AtlDropDownMenuItemProps } from './props.ts';

@customElement(TagNames.DropDownMenuItem)
export class AtlDropDownMenuItem
   extends LitElement
   implements AtlDropDownMenuItemProps
{
   declare size?: Sizes;

   static properties = {
      size: { type: String, converter: enumAttributeConverter(Sizes) },
   };

   constructor() {
      super();
      this.addEventListener('click', () => {
         this.dispatchEvent(
            new Event(DropDownMenuItemClickEvent.EVENT_NAME, {
               bubbles: true,
               composed: true,
            })
         );
      });

      this.addEventListener('keydown', (e: KeyboardEvent) => {
         if (e.key === 'Enter' && !e.repeat) {
            e.preventDefault();
            this.click();
         }
         if (e.key === ' ') {
            // Prevent page scroll; activation happens on keyup to match native button behavior.
            e.preventDefault();
         }
      });

      this.addEventListener('keyup', (e: KeyboardEvent) => {
         if (e.key === ' ' && !e.repeat) {
            e.preventDefault();
            this.click();
         }
      });
   }

   connectedCallback() {
      super.connectedCallback();
      this.setAttribute('role', 'menuitem');
      if (!this.hasAttribute('tabindex')) {
         this.setAttribute('tabindex', '0');
      }
   }

   static styles = [...getGlobalStyleSheets()];

   render() {
      const classesToApply = ['dropdown-item', 'rounded', 'p-2'];
      classesToApply.push(SizesValuesMap[this.size ?? Sizes.Medium]);

      return html`
         <div
            class="${classesToApply.join(' ')}"
            data-type="user-profile-menu-item"
         >
            <slot></slot>
         </div>
      `;
   }
}
